import { Injectable } from '@angular/core';
import { EnumLangActions, LoadLangsSuccess } from '@library/store/lang/lang.actions';
import { LangFacade } from '@library/store/lang/lang.facade';
import { Actions, ofType } from '@ngrx/effects';
import { DefaultLanguage, getCrowdinCode } from '@store/langs/supportedLangs';
import { CookieService } from 'ngx-cookie-service';
import { take, tap } from 'rxjs/operators';
import { WebappLangFacade } from './webapp-langs.facade';

@Injectable()
export class LangsResolver {
  constructor(
    private readonly action$: Actions,
    private readonly langFacade: LangFacade,
    private readonly webappLangFacade: WebappLangFacade,
    private readonly cookieService: CookieService,
  ) { }

  resolve(): boolean {
    this.loadLangsFromCache();
    this.fetchLangs();
    this.cacheLangs();
    return true;
  }

  loadLangsFromCache(): void {
    const cachedLangs = localStorage.getItem('langs');

    if (cachedLangs !== null) {
      try {
        const langs = JSON.parse(cachedLangs);
        if (typeof langs === 'object' && langs !== null) {
          this.langFacade.setLangs(langs);
        }
        else {
          console.error('err', langs);
          throw new Error('Langs from localstorage is not an object');
        }
      }
      catch (error) {
        console.error('Cannot parse langs from localstorage');
        console.error(error);
      }
    }
  }

  fetchLangs(): void {
    const code = this.cookieService.get('netatmocomlocale');
    const crowdinCode = getCrowdinCode(code) || DefaultLanguage;

    this.webappLangFacade.loadLangs(crowdinCode);
  }

  cacheLangs(): void {
    this.action$.pipe(
      ofType<LoadLangsSuccess>(EnumLangActions.LoadLangsSuccess),
      tap(action => {
        localStorage.setItem('langs', JSON.stringify(action.payload));
      }),
      take(1),
    ).subscribe();
  }
}
